// @flow

import React from 'react';
import { defaultIconProps, type IconProps, IconSvgWrapper } from './base';

const EmailIcon = (props: IconProps) => (
  <IconSvgWrapper {...props}>
    <path
      fill={props.color}
      d="M20.604 5.12402H3.39601C2.64002 5.12402 2.02802 5.73602 2.02802 6.49202V17.508C2.02802 18.264 2.64002 18.876 3.39601 18.876H20.604C21.36 18.876 21.972 18.264 21.972 17.508V6.49202C21.972 5.73602 21.36 5.12402 20.604 5.12402ZM18.432 6.87602L12.12 11.076C12.048 11.124 11.952 11.124 11.88 11.076L5.56802 6.87602C5.38802 6.75602 5.47202 6.48002 5.68802 6.48002H18.3C18.528 6.46802 18.612 6.75602 18.432 6.87602ZM20.412 17.532H3.58802C3.46802 17.532 3.37202 17.436 3.37202 17.316V7.50002C3.37202 7.32002 3.56402 7.22402 3.70801 7.32002L11.22 12.324C11.46 12.48 11.724 12.564 11.988 12.564C12.252 12.564 12.528 12.48 12.756 12.324L20.292 7.32002C20.436 7.22402 20.628 7.33202 20.628 7.50002V17.304C20.628 17.424 20.532 17.532 20.412 17.532Z"
    />
  </IconSvgWrapper>
);

EmailIcon.defaultProps = defaultIconProps;

export default EmailIcon;
